var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cForm',{ref:"form",attrs:{"config":_vm.config,"grid":_vm.grid,"fields":_vm.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }